/* eslint no-use-before-define: 0 */  // --> OFF
import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import bootstrapStyles from './grid.min.module.css';
import styles from './grid.module.scss';
import { applyBootstrapClasses } from './apply-bootstrap-classes';
import { applyClasses, applyProps } from '../shared/js';

const Column = ({ children, ...props }) => {
  const bootstrapClasses = applyBootstrapClasses(props, bootstrapStyles);
  return (
    <div
      className={cn(
        styles.col,
        // eslint-disable-next-line react/prop-types
        props.className,
        { [bootstrapStyles.col1]: !bootstrapClasses },
        applyClasses(props, styles.col),
        bootstrapClasses
      )}
      {...applyProps(props)}
    >
      {children}
    </div>
  );
};

Column.propTypes = {
  /** The column's content */
  children: PropTypes.any,
  /** Set a small breakpoint on the column. Equivalent to `col-sm` in Bootstrap */
  sm: PropTypes.bool,
  /** Set a medium breakpoint on the column. Equivalent to `col-md` in Bootstrap */
  md: PropTypes.bool,
  /** Set a large breakpoint on the column. Equivalent to `col-lg` in Bootstrap */
  lg: PropTypes.bool,
  /** Set a extra-large breakpoint on the column. Equivalent to `col-xl` in Bootstrap */
  xl: PropTypes.bool,
  /** Force the column to span 1 column at the xs breakpoint. Equivalent to `col-1` in Bootstrap */
  col1: PropTypes.bool,
  /** Force the column to span 2 columns at the xs breakpoint. Equivalent to `col-2` in Bootstrap */
  col2: PropTypes.bool,
  /** Force the column to span 3 columns at the xs breakpoint. Equivalent to `col-3` in Bootstrap */
  col3: PropTypes.bool,
  /** Force the column to span 4 columns at the xs breakpoint. Equivalent to `col-4` in Bootstrap */
  col4: PropTypes.bool,
  /** Force the column to span 5 columns at the xs breakpoint. Equivalent to `col-5` in Bootstrap */
  col5: PropTypes.bool,
  /** Force the column to span 6 columns at the xs breakpoint. Equivalent to `col-6` in Bootstrap */
  col6: PropTypes.bool,
  /** Force the column to span 7 columns at the xs breakpoint. Equivalent to `col-7` in Bootstrap */
  col7: PropTypes.bool,
  /** Force the column to span 8 columns at the xs breakpoint. Equivalent to `col-8` in Bootstrap */
  col8: PropTypes.bool,
  /** Force the column to span 9 columns at the xs breakpoint. Equivalent to `col-9` in Bootstrap */
  col9: PropTypes.bool,
  /** Force the column to span 10 columns at the xs breakpoint. Equivalent to `col-10` in Bootstrap */
  col10: PropTypes.bool,
  /** Force the column to span 11 columns at the xs breakpoint. Equivalent to `col-11` in Bootstrap */
  col11: PropTypes.bool,
  /** Force the column to span 12 columns at the xs breakpoint. Equivalent to `col-12` in Bootstrap */
  col12: PropTypes.bool,
  /** Automatically adjust the column's span to its content at the xs breakpoint. Equivalent to `col-auto` in Bootstrap */
  colAuto: PropTypes.bool,
  /** Force the column to span 1 column at the sm breakpoint. Equivalent to `col-sm-1` in Bootstrap */
  colSm1: PropTypes.bool,
  /** Force the column to span 2 columns at the sm breakpoint. Equivalent to `col-sm-2` in Bootstrap */
  colSm2: PropTypes.bool,
  /** Force the column to span 3 columns at the sm breakpoint. Equivalent to `col-sm-3` in Bootstrap */
  colSm3: PropTypes.bool,
  /** Force the column to span 4 columns at the sm breakpoint. Equivalent to `col-sm-4` in Bootstrap */
  colSm4: PropTypes.bool,
  /** Force the column to span 5 columns at the sm breakpoint. Equivalent to `col-sm-5` in Bootstrap */
  colSm5: PropTypes.bool,
  /** Force the column to span 6 columns at the sm breakpoint. Equivalent to `col-sm-6` in Bootstrap */
  colSm6: PropTypes.bool,
  /** Force the column to span 7 columns at the sm breakpoint. Equivalent to `col-sm-7` in Bootstrap */
  colSm7: PropTypes.bool,
  /** Force the column to span 8 columns at the sm breakpoint. Equivalent to `col-sm-8` in Bootstrap */
  colSm8: PropTypes.bool,
  /** Force the column to span 9 columns at the sm breakpoint. Equivalent to `col-sm-9` in Bootstrap */
  colSm9: PropTypes.bool,
  /** Force the column to span 10 columns at the sm breakpoint. Equivalent to `col-sm-10` in Bootstrap */
  colSm10: PropTypes.bool,
  /** Force the column to span 11 columns at the sm breakpoint. Equivalent to `col-sm-11` in Bootstrap */
  colSm11: PropTypes.bool,
  /** Force the column to span 12 columns at the sm breakpoint. Equivalent to `col-sm-12` in Bootstrap */
  colSm12: PropTypes.bool,
  /** Automatically adjust the column's span to its content at the sm breakpoint. Equivalent to `col-sm-auto` in Bootstrap */
  colSmAuto: PropTypes.bool,
  /** Force the column to span 1 column at the md breakpoint. Equivalent to `col-md-1` in Bootstrap */
  colMd1: PropTypes.bool,
  /** Force the column to span 2 columns at the md breakpoint. Equivalent to `col-md-2` in Bootstrap */
  colMd2: PropTypes.bool,
  /** Force the column to span 3 columns at the md breakpoint. Equivalent to `col-md-3` in Bootstrap */
  colMd3: PropTypes.bool,
  /** Force the column to span 4 columns at the md breakpoint. Equivalent to `col-md-4` in Bootstrap */
  colMd4: PropTypes.bool,
  /** Force the column to span 5 columns at the md breakpoint. Equivalent to `col-md-5` in Bootstrap */
  colMd5: PropTypes.bool,
  /** Force the column to span 6 columns at the md breakpoint. Equivalent to `col-md-6` in Bootstrap */
  colMd6: PropTypes.bool,
  /** Force the column to span 7 columns at the md breakpoint. Equivalent to `col-md-7` in Bootstrap */
  colMd7: PropTypes.bool,
  /** Force the column to span 8 columns at the md breakpoint. Equivalent to `col-md-8` in Bootstrap */
  colMd8: PropTypes.bool,
  /** Force the column to span 9 columns at the md breakpoint. Equivalent to `col-md-9` in Bootstrap */
  colMd9: PropTypes.bool,
  /** Force the column to span 10 columns at the md breakpoint. Equivalent to `col-md-10` in Bootstrap */
  colMd10: PropTypes.bool,
  /** Force the column to span 11 columns at the md breakpoint. Equivalent to `col-md-11` in Bootstrap */
  colMd11: PropTypes.bool,
  /** Force the column to span 12 columns at the md breakpoint. Equivalent to `col-md-12` in Bootstrap */
  colMd12: PropTypes.bool,
  /** Automatically adjust the column's span to its content at the md breakpoint. Equivalent to `col-md-auto` in Bootstrap */
  colMdAuto: PropTypes.bool,
  /** Force the column to span 1 column at the lg breakpoint. Equivalent to `col-lg-1` in Bootstrap */
  colLg1: PropTypes.bool,
  /** Force the column to span 2 columns at the lg breakpoint. Equivalent to `col-lg-2` in Bootstrap */
  colLg2: PropTypes.bool,
  /** Force the column to span 3 columns at the lg breakpoint. Equivalent to `col-lg-3` in Bootstrap */
  colLg3: PropTypes.bool,
  /** Force the column to span 4 columns at the lg breakpoint. Equivalent to `col-lg-4` in Bootstrap */
  colLg4: PropTypes.bool,
  /** Force the column to span 5 columns at the lg breakpoint. Equivalent to `col-lg-5` in Bootstrap */
  colLg5: PropTypes.bool,
  /** Force the column to span 6 columns at the lg breakpoint. Equivalent to `col-lg-6` in Bootstrap */
  colLg6: PropTypes.bool,
  /** Force the column to span 7 columns at the lg breakpoint. Equivalent to `col-lg-7` in Bootstrap */
  colLg7: PropTypes.bool,
  /** Force the column to span 8 columns at the lg breakpoint. Equivalent to `col-lg-8` in Bootstrap */
  colLg8: PropTypes.bool,
  /** Force the column to span 9 columns at the lg breakpoint. Equivalent to `col-lg-9` in Bootstrap */
  colLg9: PropTypes.bool,
  /** Force the column to span 10 columns at the lg breakpoint. Equivalent to `col-lg-10` in Bootstrap */
  colLg10: PropTypes.bool,
  /** Force the column to span 11 columns at the lg breakpoint. Equivalent to `col-lg-11` in Bootstrap */
  colLg11: PropTypes.bool,
  /** Force the column to span 12 columns at the lg breakpoint. Equivalent to `col-lg-12` in Bootstrap */
  colLg12: PropTypes.bool,
  /** Automatically adjust the column's span to its content at the lg breakpoint. Equivalent to `col-lg-auto` in Bootstrap */
  colLgAuto: PropTypes.bool,
  /** Force the column to span 1 column at the xl breakpoint. Equivalent to `col-xl-1` in Bootstrap */
  colXl1: PropTypes.bool,
  /** Force the column to span 2 columns at the xl breakpoint. Equivalent to `col-xl-2` in Bootstrap */
  colXl2: PropTypes.bool,
  /** Force the column to span 3 columns at the xl breakpoint. Equivalent to `col-xl-3` in Bootstrap */
  colXl3: PropTypes.bool,
  /** Force the column to span 4 columns at the xl breakpoint. Equivalent to `col-xl-4` in Bootstrap */
  colXl4: PropTypes.bool,
  /** Force the column to span 5 columns at the xl breakpoint. Equivalent to `col-xl-5` in Bootstrap */
  colXl5: PropTypes.bool,
  /** Force the column to span 6 columns at the xl breakpoint. Equivalent to `col-xl-6` in Bootstrap */
  colXl6: PropTypes.bool,
  /** Force the column to span 7 columns at the xl breakpoint. Equivalent to `col-xl-7` in Bootstrap */
  colXl7: PropTypes.bool,
  /** Force the column to span 8 columns at the xl breakpoint. Equivalent to `col-xl-8` in Bootstrap */
  colXl8: PropTypes.bool,
  /** Force the column to span 9 columns at the xl breakpoint. Equivalent to `col-xl-9` in Bootstrap */
  colXl9: PropTypes.bool,
  /** Force the column to span 10 columns at the xl breakpoint. Equivalent to `col-xl-10` in Bootstrap */
  colXl10: PropTypes.bool,
  /** Force the column to span 11 columns at the xl breakpoint. Equivalent to `col-xl-11` in Bootstrap */
  colXl11: PropTypes.bool,
  /** Force the column to span 12 columns at the xl breakpoint. Equivalent to `col-xl-12` in Bootstrap */
  colXl12: PropTypes.bool,
  /** Automatically adjust the column's span to its content at the xl breakpoint. Equivalent to `col-xl-auto` in Bootstrap */
  colXlAuto: PropTypes.bool,
  /** Align the column to the top of its row */
  alignSelfStart: PropTypes.bool,
  /** Align the column to the center of its row */
  alignSelfCenter: PropTypes.bool,
  /** Align the column to the bottom of its row */
  alignSelfEnd: PropTypes.bool,
  /** Set the column to the first position in its row. Equivalent to `order-1` in Bootstrap */
  order1: PropTypes.bool,
  /** Set the column to the second position in its row. Equivalent to `order-2` in Bootstrap */
  order2: PropTypes.bool,
  /** Set the column to the third position in its row. Equivalent to `order-3` in Bootstrap */
  order3: PropTypes.bool,
  /** Set the column to the fourth position in its row. Equivalent to `order-4` in Bootstrap */
  order4: PropTypes.bool,
  /** Set the column to the fifth position in its row. Equivalent to `order-5` in Bootstrap */
  order5: PropTypes.bool,
  /** Set the column to the sixth position in its row. Equivalent to `order-6` in Bootstrap */
  order6: PropTypes.bool,
  /** Set the column to the seventh position in its row. Equivalent to `order-7` in Bootstrap */
  order7: PropTypes.bool,
  /** Set the column to the eighth position in its row. Equivalent to `order-8` in Bootstrap */
  order8: PropTypes.bool,
  /** Set the column to the ninth position in its row. Equivalent to `order-9` in Bootstrap */
  order9: PropTypes.bool,
  /** Set the column to the tenth position in its row. Equivalent to `order-10` in Bootstrap */
  order10: PropTypes.bool,
  /** Set the column to the eleventh position in its row. Equivalent to `order-11` in Bootstrap */
  order11: PropTypes.bool,
  /** Set the column to the twelfth position in its row. Equivalent to `order-12` in Bootstrap */
  order12: PropTypes.bool,
  /** Set the column to the last position in its row. Equivalent to `order-12` in Bootstrap */
  orderLast: PropTypes.bool,
  /** Set the column to the first position in its row. Equivalent to `order-12` in Bootstrap */
  orderFirst: PropTypes.bool,
  /** Offset the column by 1 column at the xs breakpoint. Equivalent to `offset-1` in Bootstrap */
  offset1: PropTypes.bool,
  /** Offset the column by 2 columns at the xs breakpoint. Equivalent to `offset-2` in Bootstrap */
  offset2: PropTypes.bool,
  /** Offset the column by 3 columns at the xs breakpoint. Equivalent to `offset-3` in Bootstrap */
  offset3: PropTypes.bool,
  /** Offset the column by 4 columns at the xs breakpoint. Equivalent to `offset-4` in Bootstrap */
  offset4: PropTypes.bool,
  /** Offset the column by 5 columns at the xs breakpoint. Equivalent to `offset-5` in Bootstrap */
  offset5: PropTypes.bool,
  /** Offset the column by 6 columns at the xs breakpoint. Equivalent to `offset-6` in Bootstrap */
  offset6: PropTypes.bool,
  /** Offset the column by 7 columns at the xs breakpoint. Equivalent to `offset-7` in Bootstrap */
  offset7: PropTypes.bool,
  /** Offset the column by 8 columns at the xs breakpoint. Equivalent to `offset-8` in Bootstrap */
  offset8: PropTypes.bool,
  /** Offset the column by 9 columns at the xs breakpoint. Equivalent to `offset-9` in Bootstrap */
  offset9: PropTypes.bool,
  /** Offset the column by 10 columns at the xs breakpoint. Equivalent to `offset-10` in Bootstrap */
  offset10: PropTypes.bool,
  /** Offset the column by 11 columns at the xs breakpoint. Equivalent to `offset-11` in Bootstrap */
  offset11: PropTypes.bool,
  /** Offset the column by 12 columns at the xs breakpoint. Equivalent to `offset-12` in Bootstrap */
  offset12: PropTypes.bool,
  /** Offset the column by 1 column at the sm breakpoint. Equivalent to `offset-sm-1` in Bootstrap */
  offsetSm1: PropTypes.bool,
  /** Offset the column by 2 columns at the sm breakpoint. Equivalent to `offset-sm-2` in Bootstrap */
  offsetSm2: PropTypes.bool,
  /** Offset the column by 3 columns at the sm breakpoint. Equivalent to `offset-sm-3` in Bootstrap */
  offsetSm3: PropTypes.bool,
  /** Offset the column by 4 columns at the sm breakpoint. Equivalent to `offset-sm-4` in Bootstrap */
  offsetSm4: PropTypes.bool,
  /** Offset the column by 5 columns at the sm breakpoint. Equivalent to `offset-sm-5` in Bootstrap */
  offsetSm5: PropTypes.bool,
  /** Offset the column by 6 columns at the sm breakpoint. Equivalent to `offset-sm-6` in Bootstrap */
  offsetSm6: PropTypes.bool,
  /** Offset the column by 7 columns at the sm breakpoint. Equivalent to `offset-sm-7` in Bootstrap */
  offsetSm7: PropTypes.bool,
  /** Offset the column by 8 columns at the sm breakpoint. Equivalent to `offset-sm-8` in Bootstrap */
  offsetSm8: PropTypes.bool,
  /** Offset the column by 9 columns at the sm breakpoint. Equivalent to `offset-sm-9` in Bootstrap */
  offsetSm9: PropTypes.bool,
  /** Offset the column by 10 columns at the sm breakpoint. Equivalent to `offset-sm-10` in Bootstrap */
  offsetSm10: PropTypes.bool,
  /** Offset the column by 11 columns at the sm breakpoint. Equivalent to `offset-sm-11` in Bootstrap */
  offsetSm11: PropTypes.bool,
  /** Offset the column by 12 columns at the sm breakpoint. Equivalent to `offset-sm-12` in Bootstrap */
  offsetSm12: PropTypes.bool,
  /** Offset the column by 1 column at the md breakpoint. Equivalent to `offset-md-1` in Bootstrap */
  offsetMd1: PropTypes.bool,
  /** Offset the column by 2 columns at the md breakpoint. Equivalent to `offset-md-2` in Bootstrap */
  offsetMd2: PropTypes.bool,
  /** Offset the column by 3 columns at the md breakpoint. Equivalent to `offset-md-3` in Bootstrap */
  offsetMd3: PropTypes.bool,
  /** Offset the column by 4 columns at the md breakpoint. Equivalent to `offset-md-4` in Bootstrap */
  offsetMd4: PropTypes.bool,
  /** Offset the column by 5 columns at the md breakpoint. Equivalent to `offset-md-5` in Bootstrap */
  offsetMd5: PropTypes.bool,
  /** Offset the column by 6 columns at the md breakpoint. Equivalent to `offset-md-6` in Bootstrap */
  offsetMd6: PropTypes.bool,
  /** Offset the column by 7 columns at the md breakpoint. Equivalent to `offset-md-7` in Bootstrap */
  offsetMd7: PropTypes.bool,
  /** Offset the column by 8 columns at the md breakpoint. Equivalent to `offset-md-8` in Bootstrap */
  offsetMd8: PropTypes.bool,
  /** Offset the column by 9 columns at the md breakpoint. Equivalent to `offset-md-9` in Bootstrap */
  offsetMd9: PropTypes.bool,
  /** Offset the column by 10 columns at the md breakpoint. Equivalent to `offset-md-10` in Bootstrap */
  offsetMd10: PropTypes.bool,
  /** Offset the column by 11 columns at the md breakpoint. Equivalent to `offset-md-11` in Bootstrap */
  offsetMd11: PropTypes.bool,
  /** Offset the column by 12 columns at the md breakpoint. Equivalent to `offset-md-12` in Bootstrap */
  offsetMd12: PropTypes.bool,
  /** Offset the column by 1 column at the lg breakpoint. Equivalent to `offset-lg-1` in Bootstrap */
  offsetLg1: PropTypes.bool,
  /** Offset the column by 2 columns at the lg breakpoint. Equivalent to `offset-lg-2` in Bootstrap */
  offsetLg2: PropTypes.bool,
  /** Offset the column by 3 columns at the lg breakpoint. Equivalent to `offset-lg-3` in Bootstrap */
  offsetLg3: PropTypes.bool,
  /** Offset the column by 4 columns at the lg breakpoint. Equivalent to `offset-lg-4` in Bootstrap */
  offsetLg4: PropTypes.bool,
  /** Offset the column by 5 columns at the lg breakpoint. Equivalent to `offset-lg-5` in Bootstrap */
  offsetLg5: PropTypes.bool,
  /** Offset the column by 6 columns at the lg breakpoint. Equivalent to `offset-lg-6` in Bootstrap */
  offsetLg6: PropTypes.bool,
  /** Offset the column by 7 columns at the lg breakpoint. Equivalent to `offset-lg-7` in Bootstrap */
  offsetLg7: PropTypes.bool,
  /** Offset the column by 8 columns at the lg breakpoint. Equivalent to `offset-lg-8` in Bootstrap */
  offsetLg8: PropTypes.bool,
  /** Offset the column by 9 columns at the lg breakpoint. Equivalent to `offset-lg-9` in Bootstrap */
  offsetLg9: PropTypes.bool,
  /** Offset the column by 10 columns at the lg breakpoint. Equivalent to `offset-lg-10` in Bootstrap */
  offsetLg10: PropTypes.bool,
  /** Offset the column by 11 columns at the lg breakpoint. Equivalent to `offset-lg-11` in Bootstrap */
  offsetLg11: PropTypes.bool,
  /** Offset the column by 12 columns at the lg breakpoint. Equivalent to `offset-lg-12` in Bootstrap */
  offsetLg12: PropTypes.bool,
  /** Offset the column by 1 column at the xl breakpoint. Equivalent to `offset-xl-1` in Bootstrap */
  offsetXl1: PropTypes.bool,
  /** Offset the column by 2 columns at the xl breakpoint. Equivalent to `offset-xl-2` in Bootstrap */
  offsetXl2: PropTypes.bool,
  /** Offset the column by 3 columns at the xl breakpoint. Equivalent to `offset-xl-3` in Bootstrap */
  offsetXl3: PropTypes.bool,
  /** Offset the column by 4 columns at the xl breakpoint. Equivalent to `offset-xl-4` in Bootstrap */
  offsetXl4: PropTypes.bool,
  /** Offset the column by 5 columns at the xl breakpoint. Equivalent to `offset-xl-5` in Bootstrap */
  offsetXl5: PropTypes.bool,
  /** Offset the column by 6 columns at the xl breakpoint. Equivalent to `offset-xl-6` in Bootstrap */
  offsetXl6: PropTypes.bool,
  /** Offset the column by 7 columns at the xl breakpoint. Equivalent to `offset-xl-7` in Bootstrap */
  offsetXl7: PropTypes.bool,
  /** Offset the column by 8 columns at the xl breakpoint. Equivalent to `offset-xl-8` in Bootstrap */
  offsetXl8: PropTypes.bool,
  /** Offset the column by 9 columns at the xl breakpoint. Equivalent to `offset-xl-9` in Bootstrap */
  offsetXl9: PropTypes.bool,
  /** Offset the column by 10 columns at the xl breakpoint. Equivalent to `offset-xl-10` in Bootstrap */
  offsetXl10: PropTypes.bool,
  /** Offset the column by 11 columns at the xl breakpoint. Equivalent to `offset-xl-11` in Bootstrap */
  offsetXl11: PropTypes.bool,
  /** Offset the column by 12 columns at the xl breakpoint. Equivalent to `offset-xl-12` in Bootstrap */
  offsetXl12: PropTypes.bool,
};

Column.defaultProps = {
  children: undefined,
  sm: false,
  md: false,
  lg: false,
  xl: false,
  col1: false,
  col2: false,
  col3: false,
  col4: false,
  col5: false,
  col6: false,
  col7: false,
  col8: false,
  col9: false,
  col10: false,
  col11: false,
  col12: false,
  colAuto: false,
  colSm1: false,
  colSm2: false,
  colSm3: false,
  colSm4: false,
  colSm5: false,
  colSm6: false,
  colSm7: false,
  colSm8: false,
  colSm9: false,
  colSm10: false,
  colSm11: false,
  colSm12: false,
  colSmAuto: false,
  colMd1: false,
  colMd2: false,
  colMd3: false,
  colMd4: false,
  colMd5: false,
  colMd6: false,
  colMd7: false,
  colMd8: false,
  colMd9: false,
  colMd10: false,
  colMd11: false,
  colMd12: false,
  colMdAuto: false,
  colLg1: false,
  colLg2: false,
  colLg3: false,
  colLg4: false,
  colLg5: false,
  colLg6: false,
  colLg7: false,
  colLg8: false,
  colLg9: false,
  colLg10: false,
  colLg11: false,
  colLg12: false,
  colLgAuto: false,
  colXl1: false,
  colXl2: false,
  colXl3: false,
  colXl4: false,
  colXl5: false,
  colXl6: false,
  colXl7: false,
  colXl8: false,
  colXl9: false,
  colXl10: false,
  colXl11: false,
  colXl12: false,
  colXlAuto: false,
  alignSelfStart: false,
  alignSelfCenter: false,
  alignSelfEnd: false,
  order1: false,
  order2: false,
  order3: false,
  order4: false,
  order5: false,
  order6: false,
  order7: false,
  order8: false,
  order9: false,
  order10: false,
  order11: false,
  order12: false,
  orderLast: false,
  orderFirst: false,
  offset1: false,
  offset2: false,
  offset3: false,
  offset4: false,
  offset5: false,
  offset6: false,
  offset7: false,
  offset8: false,
  offset9: false,
  offset10: false,
  offset11: false,
  offset12: false,
  offsetSm1: false,
  offsetSm2: false,
  offsetSm3: false,
  offsetSm4: false,
  offsetSm5: false,
  offsetSm6: false,
  offsetSm7: false,
  offsetSm8: false,
  offsetSm9: false,
  offsetSm10: false,
  offsetSm11: false,
  offsetSm12: false,
  offsetMd1: false,
  offsetMd2: false,
  offsetMd3: false,
  offsetMd4: false,
  offsetMd5: false,
  offsetMd6: false,
  offsetMd7: false,
  offsetMd8: false,
  offsetMd9: false,
  offsetMd10: false,
  offsetMd11: false,
  offsetMd12: false,
  offsetLg1: false,
  offsetLg2: false,
  offsetLg3: false,
  offsetLg4: false,
  offsetLg5: false,
  offsetLg6: false,
  offsetLg7: false,
  offsetLg8: false,
  offsetLg9: false,
  offsetLg10: false,
  offsetLg11: false,
  offsetLg12: false,
  offsetXl1: false,
  offsetXl2: false,
  offsetXl3: false,
  offsetXl4: false,
  offsetXl5: false,
  offsetXl6: false,
  offsetXl7: false,
  offsetXl8: false,
  offsetXl9: false,
  offsetXl10: false,
  offsetXl11: false,
  offsetXl12: false,
};

export default Column;
